<template>
    <div>
      <div class="cot_cung3_4_5_6">
        <item-cung
          v-for="value in [6, 5, 4, 3]"
          :key="value"
          :so-cung="value"
          :cung-a="thapNhiCung[value]"
          :cung-b="thapNhiCung[value + 1]"
          :is-show-tu-hoa-dv="isShowTuHoaDv"
          :is-show-tu-hoa-cp="isShowTuHoaCp"
          :is-tu-hoa-in="isTuHoaIn"
          :show-star="showStar"
        />
      </div>
      <div class="cot_cung1_2_tt_7_8">
        <item-cung
          v-for="value in [7, 8]"
          :key="value"
          :so-cung="value"
          :cung-a="thapNhiCung[value]"
          :cung-b="thapNhiCung[value + 1]"
          :is-show-tu-hoa-dv="isShowTuHoaDv"
          :is-show-tu-hoa-cp="isShowTuHoaCp"
          :is-tu-hoa-in="isTuHoaIn"
          :show-star="showStar"
        />
        <div class="cot_trungtam">
          <div class="center_trungtam">
            <table>
              <tbody>
              <tr class="mb_color_hoten">
                <td><label>Họ tên:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct" colspan="3">{{thienBan.ten}}</td>
              </tr>
              <tr>
                <td><label>Năm:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{thienBan.namDuong}}</td>
                <td class="trungtam_ct"></td>
                <td class="trungtam_ct">{{thienBan.canNamTen}} {{thienBan.chiNamTen}}</td>
              </tr>
              <tr>
                <td><label>Tháng:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{thienBan.thangDuong}}</td>
                <td class="trungtam_ct">{{thienBan.thangAm}}</td>
                <td class="trungtam_ct">{{thienBan.canThangTen}} {{thienBan.chiThangTen}}</td>
              </tr>
              <tr>
                <td><label>Ngày:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{thienBan.ngayDuong}}</td>
                <td class="trungtam_ct">{{thienBan.ngayAm}}</td>
                <td class="trungtam_ct">{{thienBan.canNgayTen}} {{thienBan.chiNgayTen}}</td>
              </tr>
              <tr>
                <td><label>Giờ:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{(thienBan.chiGioSinh.id * 2 + 22) % 24}}:30</td>
                <td class="trungtam_ct"></td>
                <td class="trungtam_ct">{{thienBan.gioSinh}}</td>

              </tr>
              <tr>
                <td><label>Năm xem:&nbsp;&nbsp;</label></td>
                <template v-if="!thienBan.daiHanXem || isShowTuHoaTv">
                  <td class="trungtam_ct">{{thienBan.curYear || curYear}}</td>
                  <td class="trungtam_ct"></td>
                  <td class="trungtam_ct">{{thienBan.namXem}}</td>
                </template>
                <td v-else class="trungtam_ct">Đại vận {{thienBan.daiHanXem}}</td>
              </tr>
              <tr v-if="!thienBan.daiHanXem || isShowTuHoaTv">
                <td></td>
                <td class="trungtam_ct"></td>
                <td class="trungtam_ct"></td>
                <td class="trungtam_ct">{{(thienBan.curYear || curYear) - thienBan.namAm + 1}} Tuổi</td>
              </tr>

              </tbody>

            </table>
            <table style="margin-top: 25px">
              <tbody>
              <tr>
                <td><label>Âm Dương:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{thienBan.amDuongNamSinh}} {{thienBan.namNu}}</td>
              </tr>
              <tr>
                <td></td>
                <td class="trungtam_ct">{{thienBan.amDuongMenh}}</td>
              </tr>
              <tr>
                <td><label>Mệnh:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{thienBan.banMenh}}</td>
              </tr>
              <tr>
                <td><label>Cục:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{thienBan.tenCuc}}</td>
              </tr>
              <tr>
                <td><label></label></td>
                <td class="trungtam_ct">{{thienBan.sinhKhac}}</td>
              </tr>
              <tr>
                <td><label></label></td>
                <td class="trungtam_ct">{{thienBan.thanCu}}</td>
              </tr>

              </tbody>
            </table>
            <table style="margin-top: 25px">
              <tbody>

              <tr>
                <td><label>Mệnh chủ:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{thienBan.menhChu}}</td>
              </tr>
              <tr>
                <td><label>Thân chủ:&nbsp;&nbsp;</label></td>
                <td class="trungtam_ct">{{thienBan.thanChu}}</td>
              </tr>
              <tr>
                <td><label></label></td>
                <td></td>
              </tr>
              </tbody>
            </table>

          </div>
          <div class="img-block align-self-center" style="position: absolute;right: 209px;z-index: 500">
            <div class="text-uppercase text-logo">Thăng Long Dịch Số</div>
            <img width="80" src="@/assets/img/logo_dichso.jpg" alt="">
          </div>
        </div>
        <item-cung
          v-for="value in [2, 1]"
          :key="value"
          :so-cung="value"
          :cung-a="thapNhiCung[value]"
          :cung-b="thapNhiCung[value + 1]"
          :is-show-tu-hoa-dv="isShowTuHoaDv"
          :is-show-tu-hoa-cp="isShowTuHoaCp"
          :is-tu-hoa-in="isTuHoaIn"
          :show-star="showStar"
        />
      </div>
      <div class="cot_cung9_10_11_12">
        <item-cung
          v-for="value in [9, 10, 11, 12]"
          :key="value"
          :so-cung="value"
          :cung-a="thapNhiCung[value]"
          :cung-b="thapNhiCung[value === 12 ? 1 : value + 1]"
          :is-show-tu-hoa-dv="isShowTuHoaDv"
          :is-show-tu-hoa-cp="isShowTuHoaCp"
          :is-tu-hoa-in="isTuHoaIn"
          :show-star="showStar"
        />
      </div>
    </div>
</template>

<script>
import ItemCung from './ItemCung'
export default {
  name: 'DiaBan',
  props: {
    thapNhiCung: {
      type: [Array, Object],
      default: null
    },
    thienBan: {
      type: [Array, Object],
      default: null
    },
    year: {
      type: Number,
      default: null
    },
    curYear: {
      type: [Number, String],
      default: null
    },
    isShowTuHoaDv: {
      type: Boolean,
      default: false
    },
    isShowTuHoaTv: {
      type: Boolean,
      default: false
    },
    isShowTuHoaCp: {
      type: Boolean,
      default: false
    },
    isTuHoaIn: {
      type: Boolean,
      default: false
    },
    showStar: {
      type: Array,
      default: () => ([])
    }
  },
  components: {
    ItemCung
  }
}
</script>

<style scoped src="../../assets/css/tuvi.css" />
<style scoped src="../../assets/css/bootstrap.min.css" />
